module.exports = __webpack_public_path__ + "img/skills.5aeba30a.svg";